import 'react-dates/initialize'
import merge from 'deepmerge'
import ThemedStyleSheet from 'react-with-styles/lib/ThemedStyleSheet'
import aphroditeInterface from 'react-with-styles-interface-aphrodite'
import DefaultTheme from 'react-dates/lib/theme/DefaultTheme'
import { constants } from 'mage-deps/@klarna/bubble-ui'
const { Colors } = constants

const c = x => x.toString()

const selectionColors = {
  backgroundColor: c(Colors.PRIMARY),
  backgroundColor_active: c(Colors.PRIMARY),
  backgroundColor_hover: c(Colors.PRIMARY_HOVER),
  borderColor: c(Colors.PRIMARY),
  borderColor_active: c(Colors.PRIMARY),
  borderColor_hover: c(Colors.PRIMARY_HOVER),
  color: c(Colors.TEXT_WHITE),
  color_active: c(Colors.TEXT_WHITE),
  color_hover: c(Colors.TEXT_WHITE)
}

const spanColors = merge(selectionColors, {
  backgroundColor: c(Colors.PRIMARY_DISABLED),
  borderColor: c(Colors.PRIMARY_DISABLED),
  color: c(Colors.PRIMARY)
})

const theme = merge(DefaultTheme, {
  reactDates: {
    zIndex: 500,
    border: {
      input: {
        borderBottomFocused: `2px solid ${c(Colors.BLACK)}`
      }
    },
    spacing: {
      inputPadding: 0,
      displayTextPaddingTop: 5,
      displayTextPaddingBottom: 3,
      displayTextPaddingLeft: 0,
      displayTextPaddingRight: 0
    },
    color: {
      core: {
        primary: c(Colors.PRIMARY),
        secondary: c(Colors.SECONDARY)
      },
      hoveredSpan: spanColors,
      selectedSpan: spanColors,
      selected: selectionColors
    },
    font: {
      input: {
        size: 16
      }
    }
  }
})

ThemedStyleSheet.registerInterface(aphroditeInterface)
ThemedStyleSheet.registerTheme(theme)
